// v77.49 — Third-party view-event recorder.
//
// Tiny instrumentation helper that posts to /api/third-party/views
// from any page where a mediator/solicitor viewing the data should
// be auditable. The backend is the gate — non-mediator callers get
// a no-op, so it's safe to call from any page unconditionally.
//
// Usage:
//   import { recordThirdPartyView } from "@/lib/thirdPartyView";
//   useEffect(() => {
//     recordThirdPartyView({ resource_type: "court_bundle", resource_label: "Generated bundle" });
//   }, []);
//
// Deliberately fire-and-forget — no toast on failure, no retries —
// because:
//   1. The recording is for the GRANTER's audit log, not the third
//      party's UX. Surfacing failures would be confusing.
//   2. If the user is offline / the request fails, missing one
//      event is better than blocking the page.

import { api } from "@/lib/api";

const VALID_TYPES = new Set([
  "dashboard", "court_bundle", "messages", "documents",
  "expenses", "journal", "calendar", "child_profile", "history",
]);

export function recordThirdPartyView({ resource_type, resource_id, resource_label } = {}) {
  if (!VALID_TYPES.has(resource_type)) return;
  // Dispatch and ignore — never block the caller.
  api.post("/third-party/views", { resource_type, resource_id, resource_label }).catch(() => {});
}
